import { render } from "./ChatbotDashboard.vue?vue&type=template&id=24321a1a&scoped=true"
import script from "./ChatbotDashboard.vue?vue&type=script&lang=js"
export * from "./ChatbotDashboard.vue?vue&type=script&lang=js"

import "./ChatbotDashboard.vue?vue&type=style&index=0&id=24321a1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24321a1a"]])

export default __exports__